module.exports = __webpack_public_path__ + "img/sixpackcarrier87.4a6464c3.jpg";